(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breadcrumb"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.breadcrumbs a').forEach(function (link) {
    if (link.textContent.trim().toLowerCase() === 'blog') {
      link.setAttribute('href', '#');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ROOT_SELECTOR = '.psw-exs';
  const instances = new WeakMap();

  const init = (root) => {
    if (!root || instances.has(root) || root.dataset.pswExsReady === 'true') return;

    const viewport = root.querySelector('.psw-exs__viewport');
    const track = root.querySelector('.psw-exs__track');
    const originalSlides = track ? Array.from(track.querySelectorAll('[data-psw-exs-slide]')) : [];
    const dots = Array.from(root.querySelectorAll('[data-psw-exs-dot]'));
    const slideCount = originalSlides.length;

    if (!viewport || !track || slideCount < 1) return;

    root.dataset.pswExsReady = 'true';

    const autoplayEnabled = root.dataset.autoplay === 'true';
    const autoplayDelay = Math.max(1000, Number(root.dataset.autoplaySeconds || 4) * 1000);
    const transitionMs = Math.max(0, Number(root.dataset.transitionMs || 600));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const canLoop = slideCount > 1;
    const interactiveSelector = '.psw-exs__button, button, input, select, textarea, label, [role="button"], [contenteditable="true"]';

    let physicalIndex = 0;
    let slideWidth = 0;
    let timer = null;
    let dragging = false;
    let horizontalDrag = false;
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let currentDelta = 0;
    let dragStartTime = 0;
    let suppressClickUntil = 0;
    let destroyed = false;
    let enhanced = false;
    let activationQueued = false;
    let leadingClone = null;
    let trailingClone = null;

    const hydrateSlideMedia = (slide) => {
      if (!slide || slide.dataset.pswExsMediaReady === 'true') return;

      slide.querySelectorAll('source[data-srcset]').forEach((source) => {
        source.srcset = source.dataset.srcset || '';
        source.sizes = source.dataset.sizes || '100vw';
        source.removeAttribute('data-srcset');
        source.removeAttribute('data-sizes');
      });

      slide.querySelectorAll('img[data-src]').forEach((image) => {
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.sizes) image.sizes = image.dataset.sizes;
        image.src = image.dataset.src;
        image.loading = 'lazy';
        image.fetchPriority = 'low';
        image.decoding = 'async';
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');
        image.removeAttribute('data-sizes');
      });

      slide.dataset.pswExsMediaReady = 'true';
    };

    const cleanClone = (slide) => {
      const clone = slide.cloneNode(true);
      clone.removeAttribute('data-shopify-editor-block');

      clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
        element.removeAttribute('data-shopify-editor-block');
      });

      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');

      clone.querySelectorAll('img').forEach((image) => {
        image.loading = 'lazy';
        image.fetchPriority = 'low';
        image.decoding = 'async';
      });

      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
        element.setAttribute('tabindex', '-1');
        element.setAttribute('aria-hidden', 'true');
      });

      return clone;
    };

    const logicalIndex = () => {
      if (!canLoop || !enhanced) return 0;
      return (physicalIndex - 1 + slideCount) % slideCount;
    };

    const hydratePhysicalTarget = (target) => {
      if (!enhanced || !canLoop || destroyed) return;

      if (target <= 0) {
        hydrateSlideMedia(originalSlides[slideCount - 1]);
        hydrateSlideMedia(leadingClone);
        return;
      }

      if (target >= slideCount + 1) {
        hydrateSlideMedia(originalSlides[0]);
        hydrateSlideMedia(trailingClone);
        return;
      }

      hydrateSlideMedia(originalSlides[target - 1]);
    };

    const primeNextMedia = () => {
      if (!enhanced || !canLoop || destroyed) return;
      const nextIndex = (logicalIndex() + 1) % slideCount;
      hydrateSlideMedia(originalSlides[nextIndex]);
    };

    const setPosition = (animate = true, dragOffset = 0) => {
      const percentage = physicalIndex * -100;
      const x = dragOffset === 0 ? `${percentage}%` : `calc(${percentage}% + ${dragOffset}px)`;

      track.style.willChange = animate || dragOffset !== 0 ? 'transform' : 'auto';
      track.style.transition = animate && !reducedMotion.matches
        ? `transform ${transitionMs}ms cubic-bezier(0.22, 1, 0.36, 1)`
        : 'none';
      track.style.transform = `translate3d(${x}, 0, 0)`;
    };

    const updateAccessibility = () => {
      const activeIndex = logicalIndex();

      originalSlides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');

        slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          if (active) {
            element.removeAttribute('tabindex');
            element.removeAttribute('aria-hidden');
          } else {
            element.setAttribute('tabindex', '-1');
          }
        });
      });

      dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
      });
    };

    const goToPhysical = (target, animate = true) => {
      hydratePhysicalTarget(target);
      physicalIndex = target;
      setPosition(animate);
      updateAccessibility();
    };

    const goToLogical = (target, animate = true) => {
      const safeTarget = Math.max(0, Math.min(slideCount - 1, target));
      hydrateSlideMedia(originalSlides[safeTarget]);
      goToPhysical(canLoop ? safeTarget + 1 : 0, animate);
    };

    const next = () => {
      if (canLoop && enhanced && !dragging) goToPhysical(physicalIndex + 1, true);
    };

    const previous = () => {
      if (canLoop && enhanced && !dragging) goToPhysical(physicalIndex - 1, true);
    };

    const stopAutoplay = () => {
      if (timer !== null) {
        window.clearTimeout(timer);
        timer = null;
      }
    };

    const scheduleAutoplay = () => {
      stopAutoplay();

      if (!enhanced || !autoplayEnabled || !canLoop || reducedMotion.matches || document.hidden || destroyed || dragging) return;

      timer = window.setTimeout(() => {
        next();
        scheduleAutoplay();
      }, autoplayDelay);
    };

    const normalizeLoop = () => {
      if (!canLoop || !enhanced) return;

      if (physicalIndex === 0) {
        physicalIndex = slideCount;
        setPosition(false);
      } else if (physicalIndex === slideCount + 1) {
        physicalIndex = 1;
        setPosition(false);
      }

      updateAccessibility();
    };

    const onTransitionEnd = (event) => {
      if (event.target !== track || event.propertyName !== 'transform') return;
      normalizeLoop();
      track.style.willChange = 'auto';
      primeNextMedia();
    };

    const cancelDrag = () => {
      if (!dragging) return;
      dragging = false;
      horizontalDrag = false;
      currentDelta = 0;
      pointerId = null;
      viewport.classList.remove('is-dragging');
      setPosition(true);
      scheduleAutoplay();
    };

    const onPointerDown = (event) => {
      if (!enhanced || !canLoop || destroyed) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest(interactiveSelector)) return;

      dragging = true;
      horizontalDrag = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      currentDelta = 0;
      dragStartTime = performance.now();
      slideWidth = Math.max(1, viewport.clientWidth);
      stopAutoplay();
      viewport.classList.add('is-dragging');
      track.style.transition = 'none';
      track.style.willChange = 'transform';
      viewport.setPointerCapture?.(event.pointerId);
    };

    const onPointerMove = (event) => {
      if (!dragging || event.pointerId !== pointerId) return;

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;

      if (!horizontalDrag) {
        if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < 6) return;

        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          cancelDrag();
          return;
        }

        horizontalDrag = true;
      }

      event.preventDefault();
      currentDelta = deltaX;
      setPosition(false, currentDelta);
    };

    const finishDrag = (event) => {
      if (!dragging || (event.pointerId !== undefined && event.pointerId !== pointerId)) return;

      const elapsed = Math.max(1, performance.now() - dragStartTime);
      const velocity = currentDelta / elapsed;
      const distanceThreshold = Math.min(100, slideWidth * 0.12);
      const changedSlide = horizontalDrag && (
        Math.abs(currentDelta) >= distanceThreshold ||
        Math.abs(velocity) >= 0.45
      );

      dragging = false;
      viewport.classList.remove('is-dragging');
      viewport.releasePointerCapture?.(pointerId);
      pointerId = null;

      if (changedSlide) {
        suppressClickUntil = Date.now() + 350;
        if (currentDelta < 0) goToPhysical(physicalIndex + 1, true);
        else goToPhysical(physicalIndex - 1, true);
      } else {
        setPosition(true);
      }

      horizontalDrag = false;
      currentDelta = 0;
      scheduleAutoplay();
    };

    const onClickCapture = (event) => {
      if (Date.now() < suppressClickUntil && event.target.closest('a')) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    const onKeyDown = (event) => {
      if (!enhanced || !canLoop) return;

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        next();
        scheduleAutoplay();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        previous();
        scheduleAutoplay();
      }
    };

    const onVisibilityChange = () => {
      if (document.hidden) stopAutoplay();
      else scheduleAutoplay();
    };

    const onReducedMotionChange = () => {
      setPosition(false);
      scheduleAutoplay();
    };

    const onShopifyBlockSelect = (event) => {
      if (destroyed) return;
      if (!enhanced) enhance();

      const selected = originalSlides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
      if (selected >= 0) {
        goToLogical(selected, false);
        scheduleAutoplay();
      }
    };

    const onShopifyBlockDeselect = () => scheduleAutoplay();

    const removeListeners = () => {
      track.removeEventListener('transitionend', onTransitionEnd);
      viewport.removeEventListener('pointerdown', onPointerDown);
      viewport.removeEventListener('pointermove', onPointerMove);
      viewport.removeEventListener('pointerup', finishDrag);
      viewport.removeEventListener('pointercancel', finishDrag);
      viewport.removeEventListener('lostpointercapture', finishDrag);
      viewport.removeEventListener('click', onClickCapture, true);
      viewport.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      document.removeEventListener('shopify:block:select', onShopifyBlockSelect);
      document.removeEventListener('shopify:block:deselect', onShopifyBlockDeselect);

      if (typeof reducedMotion.removeEventListener === 'function') reducedMotion.removeEventListener('change', onReducedMotionChange);
      else if (typeof reducedMotion.removeListener === 'function') reducedMotion.removeListener(onReducedMotionChange);
    };

    const destroy = () => {
      if (destroyed) return;
      destroyed = true;
      stopAutoplay();
      removeListeners();
      root.dataset.pswExsReady = 'false';

      if (leadingClone?.parentNode === track) leadingClone.remove();
      if (trailingClone?.parentNode === track) trailingClone.remove();

      track.style.transition = '';
      track.style.transform = '';
      track.style.willChange = '';
    };

    const enhance = () => {
      if (enhanced || destroyed) return;
      enhanced = true;

      if (canLoop) {
        leadingClone = cleanClone(originalSlides[slideCount - 1]);
        trailingClone = cleanClone(originalSlides[0]);
        track.insertBefore(leadingClone, track.firstChild);
        track.appendChild(trailingClone);
        physicalIndex = 1;
      } else {
        physicalIndex = 0;
      }

      setPosition(false);
      updateAccessibility();
      primeNextMedia();

      track.addEventListener('transitionend', onTransitionEnd);
      viewport.addEventListener('pointerdown', onPointerDown);
      viewport.addEventListener('pointermove', onPointerMove, { passive: false });
      viewport.addEventListener('pointerup', finishDrag);
      viewport.addEventListener('pointercancel', finishDrag);
      viewport.addEventListener('lostpointercapture', finishDrag);
      viewport.addEventListener('click', onClickCapture, true);
      viewport.addEventListener('keydown', onKeyDown);
      document.addEventListener('visibilitychange', onVisibilityChange);
      document.addEventListener('shopify:block:select', onShopifyBlockSelect);
      document.addEventListener('shopify:block:deselect', onShopifyBlockDeselect);

      if (typeof reducedMotion.addEventListener === 'function') reducedMotion.addEventListener('change', onReducedMotionChange);
      else if (typeof reducedMotion.addListener === 'function') reducedMotion.addListener(onReducedMotionChange);

      dots.forEach((dot) => {
        dot.addEventListener('pointerdown', (event) => event.stopPropagation());
        dot.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const dotIndex = Number(dot.dataset.pswExsDot || 0);
          goToLogical(dotIndex, true);
          scheduleAutoplay();
        });
      });

      scheduleAutoplay();
    };

    const activateWhenNonCritical = () => {
      if (activationQueued || enhanced || destroyed) return;
      activationQueued = true;

      const runEnhancement = () => {
        if (enhanced || destroyed) return;
        if ('requestIdleCallback' in window) window.requestIdleCallback(() => enhance(), { timeout: 1600 });
        else window.setTimeout(enhance, 600);
      };

      if (document.readyState === 'complete') runEnhancement();
      else window.addEventListener('load', runEnhancement, { once: true });
    };

    instances.set(root, { destroy });
    activateWhenNonCritical();

    viewport.addEventListener('pointerdown', enhance, { once: true, passive: true });
    viewport.addEventListener('keydown', enhance, { once: true });
  };

  const initAll = (scope = document) => {
    if (scope instanceof Element && scope.matches(ROOT_SELECTOR)) init(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const roots = [];

    if (event.target instanceof Element && event.target.matches(ROOT_SELECTOR)) roots.push(event.target);
    event.target?.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => roots.push(root));

    roots.forEach((root) => {
      const instance = instances.get(root);
      if (instance) {
        instance.destroy();
        instances.delete(root);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
